import { defineAsyncComponent } from 'vue';

export const addComponents = app => {
    return app.component('WatsonAuthorArticles', defineAsyncComponent(() =>
        import('./author-articles/watson-theme-author-articles.vue'),
    ))
        .component('WatsonAuthorByline', defineAsyncComponent(() =>
            import('./author-byline/watson-theme-author-byline.vue'),
        ))
        .component('WatsonAuthorProfile', defineAsyncComponent(() =>
            import('./author-profile/watson-theme-author-profile.vue'),
        ))
        .component('WatsonBecomeAPartnerHighlight', defineAsyncComponent(() =>
            import('./become-a-partner-highlight/watson-theme-become-a-partner-highlight.vue'),
        ))
        .component('WatsonCard', defineAsyncComponent(() =>
            import('./card/watson-theme-card.vue'),
        ))
        .component('WatsonCtaBlock', defineAsyncComponent(() =>
            import('./cta-block/watson-theme-cta-block.vue'),
        ))
        .component('WatsonCtaButton', defineAsyncComponent(() =>
            import('./cta-button/watson-theme-cta-button.vue'),
        ))
        .component('WatsonCtaButtonWithBackground', defineAsyncComponent(() =>
            import('./cta-button-with-background/watson-theme-cta-button-with-background.vue'),
        ))
        .component('WatsonDynamicCta', defineAsyncComponent(() =>
            import('./dynamic-cta/watson-theme-dynamic-cta.vue'),
        ))
        .component('WatsonEmbedAnimation', defineAsyncComponent(() =>
            import('./embeds/embed-animation/watson-theme-embed-animation.vue'),
        ))
        .component('WatsonEmbedDataWrapper', defineAsyncComponent(() =>
            import('./embeds/embed-data-wrapper/watson-theme-embed-data-wrapper.vue'),
        ))
        .component('WatsonEmbedGoogleMyMaps', defineAsyncComponent(() =>
            import('./embeds/embed-google-my-maps/watson-theme-embed-google-my-maps.vue'),
        ))
        .component('WatsonEmbedIframe', defineAsyncComponent(() =>
            import('./embeds/embed-iframe/watson-theme-embed-iframe.vue'),
        ))
        .component('WatsonEmbedShortVideo', defineAsyncComponent(() =>
            import('./embeds/embed-short-video/watson-theme-embed-short-video.vue'),
        ))
        .component('WatsonEmbedVideo', defineAsyncComponent(() =>
            import('./embeds/embed-video/watson-theme-embed-video.vue'),
        ))
        .component('WatsonFactBox', defineAsyncComponent(() =>
            import('./fact-box/watson-theme-fact-box.vue'),
        ))
        .component('WatsonFactBoxWithImage', defineAsyncComponent(() =>
            import('./fact-box-with-image/watson-theme-fact-box-with-image.vue'),
        ))
        .component('WatsonFaq', defineAsyncComponent(() =>
            import('./faq/watson-theme-faq.vue'),
        ))
        .component('WatsonIframeEmbedCode', defineAsyncComponent(() =>
            import('./embeds/iframe-embed-code/watson-theme-iframe-embed-code.vue'),
        ))
        .component('WatsonImageEmbedCode', defineAsyncComponent(() =>
            import('./embeds/image-embed-code/watson-theme-image-embed-code.vue'),
        ))
        .component('WatsonImageList', defineAsyncComponent(() =>
            import('./image-list/watson-theme-image-list.vue'),
        ))
        .component('WatsonImageUsps', defineAsyncComponent(() =>
            import('./image-usps/watson-theme-image-usps.vue'),
        ))
        .component('WatsonImageLicenseStructuredData', defineAsyncComponent(() =>
            import('./structured-data/watson-theme-image-license-structured-data.vue'),
        ))
        .component('WatsonImageWithStatistics', defineAsyncComponent(() =>
            import('./image-with-statistics/watson-theme-image-with-statistics.vue'),
        ))
        .component('WatsonInfographicEmbedCode', defineAsyncComponent(() =>
            import('./embeds/infographic-embed-code/watson-theme-infographic-embed-code.vue'),
        ))
        .component('WatsonInformationCards', defineAsyncComponent(() =>
            import('./information-cards/watson-theme-information-cards.vue'),
        ))
        .component('WatsonInformationWithImage', defineAsyncComponent(() =>
            import('./information-with-image/watson-theme-information-with-image.vue'),
        ))
        .component('WatsonInteractiveAnimation', defineAsyncComponent(() =>
            import('./interactive-animation/watson-theme-interactive-animation.vue'),
        ))
        .component('WatsonInteractiveChart', defineAsyncComponent(() =>
            import('./interactive-chart/watson-theme-interactive-chart.vue'),
        ))
        .component('WatsonLinkButton', defineAsyncComponent(() =>
            import('./link-button/watson-theme-link-button.vue'),
        ))
        .component('WatsonLinkBlock', defineAsyncComponent(() =>
            import('./link-block/watson-theme-link-block.vue'),
        ))
        .component('WatsonListingWithImage', defineAsyncComponent(() =>
            import('./listing-with-image/watson-theme-listing-with-image.vue'),
        ))
        .component('WatsonMentionedIn', defineAsyncComponent(() =>
            import('./mentioned-in/watson-theme-mentioned-in.vue'),
        ))
        .component('WatsonNumberedImage', defineAsyncComponent(() =>
            import('./numbered-image/watson-theme-numbered-image.vue'),
        ))
        .component('WatsonOrganizationStructuredData', defineAsyncComponent(() =>
            import('./structured-data/watson-theme-organization-structured-data.vue'),
        ))
        .component('WatsonPageEmbedCode', defineAsyncComponent(() =>
            import('./embeds/page-embed-code/watson-theme-page-embed-code.vue'),
        ))
        .component('WatsonPageList', defineAsyncComponent(() =>
            import('./page-list/watson-theme-page-list.vue'),
        ))
        .component('WatsonPhotoQuoteBox', defineAsyncComponent(() =>
            import('./photo-quote-box/watson-theme-photo-quote-box.vue'),
        ))
        .component('WatsonPopularJobs', defineAsyncComponent(() =>
            import('./popular-jobs/watson-theme-popular-jobs.vue'),
        ))
        .component('WatsonProductBox', defineAsyncComponent(() =>
            import('./product-box/watson-theme-product-box.vue'),
        ))
        .component('WatsonQuoteBox', defineAsyncComponent(() =>
            import('./quote-box/watson-theme-quote-box.vue'),
        ))
        .component('WatsonQuoteForm', defineAsyncComponent(() =>
            import('./QuoteForm.vue'),
        ))
        .component('WatsonReadMore', defineAsyncComponent(() =>
            import('./read-more/watson-theme-read-more.vue'),
        ))
        .component('WatsonRegionalMap', defineAsyncComponent(() =>
            import('./regional-map/watson-theme-regional-map.vue'),
        ))
        .component('WatsonReview', defineAsyncComponent(() =>
            import('./review/watson-theme-review.vue'),
        ))
        .component('WatsonSellingPoint', defineAsyncComponent(() =>
            import('./selling-points/watson-theme-selling-points.vue'),
        ))
        .component('WatsonSolarCalculator', defineAsyncComponent(() =>
            import('./solar-calculator/watson-theme-solar-calculator.vue'),
        ))
        .component('WatsonSolarPanelCalculatorSweden', defineAsyncComponent(() =>
            import('./solar-panel-calculator-sweden/watson-theme-solar-panel-calculator-sweden.vue'),
        ))
        .component('WatsonStructuredData', defineAsyncComponent(() =>
            import('./structured-data/watson-theme-structured-data.vue'),
        ))
        .component('WatsonTableOfContents', defineAsyncComponent(() =>
            import('./table-of-contents/watson-theme-table-of-contents.vue'),
        ))
        .component('WatsonTestimonials', defineAsyncComponent(() =>
            import('./testimonials-gm/watson-theme-testimonials-gm.vue'),
        ))
        .component('WatsonTestimonialsCarousel', defineAsyncComponent(() =>
            import('./testimonials-carousel/watson-theme-testimonials-carousel.vue'),
        ))
        .component('WatsonTextOverlappingImage', defineAsyncComponent(() =>
            import('./text-overlapping-image/watson-theme-text-overlapping-image.vue'),
        ))
        .component('WatsonVideoEmbedCode', defineAsyncComponent(() =>
            import('./embeds/video-embed-code/watson-theme-video-embed-code.vue'),
        ))
        .component('WatsonYouTubeChannelHighlight', defineAsyncComponent(() =>
            import('./youtube-channel-highlight/watson-theme-youtube-channel-highlight.vue'),
        ));
};
